import { OptionCard, StepBody, StepHeader, StepNav } from "./HikvisionWizardParts";

export const CONTROL_TARGETS = [
    { key: "Gates", title: "Gates", subtitle: "Control devices connected to Hikvision outputs" },
    { key: "Cameras", title: "Cameras", subtitle: "Control camera detection and alarm inputs" },
];

const HikvisionStepControlTarget = ({ selectedControlTargets, setSelectedControlTargets, onNext, onBack }) => {
    const toggle = (key) => {
        setSelectedControlTargets(prev => prev.includes(key) ? prev.filter(x => x !== key) : [...prev, key]);
    };

    return (
        <>
            <StepHeader title="Are you controlling gates or cameras?" subtitle="Choose one or both" />
            <StepBody>
                {CONTROL_TARGETS.map(target => (
                    <OptionCard
                        key={target.key}
                        title={target.title}
                        subtitle={target.subtitle}
                        selected={selectedControlTargets.includes(target.key)}
                        onClick={() => toggle(target.key)}
                    />
                ))}
            </StepBody>
            <StepNav onBack={onBack} onNext={onNext} nextDisabled={selectedControlTargets.length === 0} />
        </>
    );
};

export default HikvisionStepControlTarget;
